import { BsInfoCircle } from "react-icons/bs";
import Tooltip from "./ToolTip";

export const HeaderToolTip = ({
  header,
  tip,
}: {
  header: string;
  tip: string;
}) => {
  return (
    <div className="flex items-center">
      {header}
      <div className="ml-1">
        <Tooltip
          content={
            <div className="min-w-[144px] text-xs text-center">{tip}</div>
          }
          position="top"
        >
          <BsInfoCircle size={12} />
        </Tooltip>
      </div>
    </div>
  );
};
